import { Controller, Payload } from "../../config/controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { Atendimento, initialValueAtendimentoState, AtendimentoState, AtendimentoActions, initialValueAtendimento, TratamentosGroup, TratamentoGroupRow, initialValueTratamento, FiltroAtendimento } from "./atendimento.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppState } from "../root/root.model";
import { PacienteActions } from "../paciente/paciente.model";
import { pacienteController } from "../paciente/paciente.controller";
import { ProcedimentoActions } from "../procedimento/procedimento.model";
import { procedimentoController } from "../procedimento/procedimento.controller";
import { addDays, previousDay } from "date-fns";
import { AtendimentoView } from "../../config/data.types";
import { formatData, getDataAmerica, getNewId, isEmpty } from "../../services/utils";
import { FiltroAtendimentoApi, getAtendimentos } from "../../services/api";


export interface AtendimentoViewProps {
    atendimentoState: AtendimentoState
    atendimentoActions: AtendimentoActions
    pacienteActions: PacienteActions
    procedimentoActions: ProcedimentoActions
}

export const listPeriodo: { periodo: string, qtdias: number }[] = [
    { periodo: "1 Mês", qtdias: 31 },
    { periodo: "2 Meses", qtdias: 60 },
    { periodo: "3 Meses", qtdias: 90 },
    { periodo: "4 Meses", qtdias: 120 },
    { periodo: "5 Meses", qtdias: 150 },
    { periodo: "6 Meses", qtdias: 180 },
    { periodo: "7 Meses", qtdias: 210 },
    { periodo: "8 Meses", qtdias: 240 },
    { periodo: "9 Meses", qtdias: 270 },
    { periodo: "10 Meses", qtdias: 300 },
    { periodo: "11 Meses", qtdias: 330 },
    { periodo: "1 ano", qtdias: 360 },
    { periodo: "2 anos", qtdias: 720 },
    { periodo: "3 anos", qtdias: 1080 },
]

class AtendimentoController extends Controller<Atendimento, AtendimentoState, AtendimentoActions> {
    constructor() {
        super(initialValueAtendimentoState.row.type, initialValueAtendimentoState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            novoAtendimento: `@${this.moduloName}/NOVO_ATENDIMENTO`,
            salvarAtendimento: `@${this.moduloName}/SALVAR_ATENDIMENTO`,
            filterAtendimentos: `@${this.moduloName}/FILTER_ATENDIMENTOS`,
            handleRealizarTratamento: `@${this.moduloName}/HANDLE_REALIZAR_TRATAMENTO`,
            handleCancelartratamento: `@${this.moduloName}/HANDLE_CANCELAR_TRATAMENTO`,
            setRowTratamentoGroup: `@${this.moduloName}/SET_ROW_TRATAMENTO_GROUP`,
            setShowModalCadTratamento: `@${this.moduloName}/SET_SHOW_MODAL_CAD_TRATAMENTO`,
            corrigirDados: `@${this.moduloName}/CORRIGIR_DADOS`,
            setFiltro: `@${this.moduloName}/SET_FILTRO`,
            setShowFormFiltro: `@${this.moduloName}/SET_SHOW_FORM_FILTRO`,
            getAtendimentosByPaciente: `@${this.moduloName}/GET_ATENDIMENTOS_BY_PACIENTE`,

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            novoAtendimento: () => action(this.actionsType.novoAtendimento),
            salvarAtendimento: (row) => action(this.actionsType.salvarAtendimento, { row }),
            filterAtendimentos: (filter) => action(this.actionsType.filterAtendimentos, { filter }),
            handleRealizarTratamento: () => action(this.actionsType.handleRealizarTratamento),
            handleCancelartratamento: () => action(this.actionsType.handleCancelartratamento),
            setRowTratamentoGroup: (row) => action(this.actionsType.setRowTratamentoGroup, { row }),
            setShowModalCadTratamento: (set, index) => action(this.actionsType.setShowModalCadTratamento, { set, index }),
            corrigirDados: (atendimentos) => action(this.actionsType.corrigirDados, { atendimentos }),
            setFiltro: (filtro) => action(this.actionsType.setFiltro, { filtro }),
            setShowFormFiltro: (show) => action(this.actionsType.setShowFormFiltro, { show }),
            getAtendimentosByPaciente: (id_paciente, procedimento_id, id_atendimento?) => action(this.actionsType.getAtendimentosByPaciente, { idPaciente: id_paciente, procedimentoId: procedimento_id, idAtendimento: id_atendimento }),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.novoAtendimento, this.novoAtendimentoEffects.bind(this)),
            takeLatest(this.actionsType.salvarAtendimento, this.salvarAtendimentoEffects.bind(this)),
            takeLatest(this.actionsType.filterAtendimentos, this.filterAtendimentosEffects.bind(this)),
            takeLatest(this.actionsType.handleRealizarTratamento, this.handleRealizarTratamentoEffects.bind(this)),
            takeLatest(this.actionsType.handleCancelartratamento, this.handleCancelartratamentoEffects.bind(this)),
            takeLatest(this.actionsType.setRowTratamentoGroup, this.setRowTratamentoGroupEffects.bind(this)),
            takeLatest(this.actionsType.setShowModalCadTratamento, this.setShowModalCadTratamentoEffects.bind(this)),
            takeLatest(this.actionsType.resultAfterEffcts, this.resultAfterAtendimentoEffcts.bind(this)),
            takeLatest(this.actionsType.corrigirDados, this.corrigirDadosEffects.bind(this)),
            takeLatest(this.actionsType.setFiltro, this.setFiltroEffects.bind(this)),
            takeLatest(this.actionsType.setShowFormFiltro, this.setShowFormFiltroEffects.bind(this)),
            takeLatest(this.actionsType.getAtendimentosByPaciente, this.getAtendimentosByPacienteEffects.bind(this)),

        ]
    }


    private * setShowFormFiltroEffects(actions: Payload) {
        let show = actions.payload.show
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, showFormFiltro: show },
            this.actionsType.setShowFormFiltroEffects
        ))
    }

    private * salvarAtendimentoEffects(actions: Payload) {
        try {
            let atendimentoSalvar = actions.payload.row as Atendimento;
            //mostrar o loading
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Salvando atendimento...", status: "", row: atendimentoSalvar },
                this.actionsType.salvarAtendimento
            ));
            //validar paciente e tratamento
            if (isEmpty(atendimentoSalvar.paciente) || isEmpty(atendimentoSalvar.tratamento.procedimento)) {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Paciente ou tratamento não informados.", status: "error", error: true, showAlert: true },
                    this.actionsType.salvarAtendimento
                ))
            }

            //verificar se o paciente ja tem algum atendimento como o mesmo procedimento e que esteja ativo
            let respAtendimentoPaciente: ResultDb<Atendimento> = yield call(this.getAtendimentosByPaciente, atendimentoSalvar.paciente._id, atendimentoSalvar.tratamento.procedimento._id, atendimentoSalvar._id);
            if (respAtendimentoPaciente.status === "ok") {
                if (respAtendimentoPaciente.rows && respAtendimentoPaciente.rows.length > 0) {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, msg: "Esse paciente já possui um atendimento com esse mesmo procedimento.", status: "error", error: true, showAlert: true },
                        this.actionsType.salvarAtendimento
                    ))
                    return;//sai do efeito para evitar salvar o atendimento
                }
            }
            //iniciar procedimento de salvar o atendimento
            if (atendimentoSalvar._rev) {
                atendimentoSalvar.modified_at = new Date().toISOString();
            } else {
                atendimentoSalvar._id = getNewId();
                atendimentoSalvar.created_at = new Date().toISOString();
            }
            let resp: ResultDb<Atendimento> = yield call(this.db.salvar, atendimentoSalvar)
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Atendimento salvo com sucesso.", status: "ok", error: false, showAlert: true },
                    this.actionsType.salvarAtendimento
                ))
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Erro ao salvar atendimento, detalhes: " + resp.msg, status: "error", error: true, showAlert: true },
                    this.actionsType.salvarAtendimento
                ))
            }

        } catch (error: any) {
            console.log("error salvarAtendimentoEffects", error);
            let msg = "Ops, ocorreu uma falha em salvarAtendimentoEffects, detalhes: ";
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg, status: "error", error: true, showAlert: true },
                this.actionsType.salvarAtendimento
            ))
        }
    }

    getAtendimentosByPaciente = async (id_paciente: string, procedimento_id: string, id_atendimento?: string): Promise<ResultDb<Atendimento>> => {
        try {
            let resp = await this.db.filter({
                fieldsFilter: [
                    { fieldName: "type", mangoQuery: "$eq", fieldValue: "atendimento" },
                    { fieldName: "paciente._id", mangoQuery: "$eq", fieldValue: id_paciente },
                    { fieldName: "tratamento.procedimento._id", mangoQuery: "$eq", fieldValue: procedimento_id },
                    { fieldName: "_id", mangoQuery: "$ne", fieldValue: id_atendimento ? id_atendimento : '' },
                ],
                indexName: "index_atendimento_paciente_id"
            });
            console.log("resp getAtendimentosByPaciente", resp)
            return { status: resp.status, msg: resp.msg, rows: resp.rows as Atendimento[] }
        } catch (error: any) {
            console.log("error getAtendimentosByPaciente", error);
            let msg = "Ops, ocorreu uma falha em getAtendimentosByPaciente, detalhes: ";
            return { status: "error", msg, rows: [] };
        }
    }

    private * getAtendimentosByPacienteEffects(actions: Payload) {
        try {
            let idPaciente = actions.payload.idPaciente as string;
            let procedimentoId = actions.payload.procedimentoId as string;
            let idAtendimento = actions.payload.idAtendimento as string | undefined;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Buscando registros de atendimento do paciente...", status: "", },
                this.actionsType.getAtendimentosByPacienteEffects
            ))
            let resp: ResultDb<Atendimento> = yield call(this.getAtendimentosByPaciente, idPaciente, procedimentoId, idAtendimento);
            console.log("resp getAtendimentosByPacienteEffects", resp)
            if (resp.status === "ok") {
                if (resp.rows && resp.rows.length > 0) {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, status: "ok", },
                        this.actionsType.getAtendimentoByIdPacienteEffects
                    ))
                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, status: "ok", msg: "Nenhum registro de atendimento encontrado para esse paciente." },
                        this.actionsType.getAtendimentoByIdPacienteEffects
                    ))
                }
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.getAtendimentoByIdPacienteEffects
                ))
            }
        } catch (error: any) {
            console.log("error getAtendimentosByPacienteEffects", error);
            let msg = "Ops, ocorreu uma falha em getAtendimentosByPacienteEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.getAtendimentosByPacienteEffects
            ))
        }
    }

    private * setFiltroEffects(actions: Payload) {
        try {
            let filtro = actions.payload.filtro as FiltroAtendimento;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, filtro: filtro },
                this.actionsType.setFiltroEffects
            ))
            yield put(this.reducer.actions.filterAtendimentos(actions.payload.filtro))
        } catch (error: any) {
            console.log("error setFiltroEffects", error);
            let msg = "Ops, ocorreu uma falha em setFiltroEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.setFiltroEffects
            ))
        }
    }

    private * resultAfterAtendimentoEffcts(actions: Payload) {
        let actionType = actions.payload.actionType;
        try {
            let state: AtendimentoState = actions.payload.result;
            if (state.status === "ok") {
                switch (actionType) {
                    case this.actionsType.salvarAtendimento:
                        yield put(this.reducer.actions.filterAtendimentos(state.filtro));
                        break;
                    case this.actionsType.update:
                        yield put(this.reducer.actions.filterAtendimentos(state.filtro));
                        break;
                    case this.actionsType.deleta:
                        yield put(this.reducer.actions.filterAtendimentos(state.filtro));
                        break;
                }
            }
        } catch (error: any) {
            console.log("error resultAfterAtendimentoEffcts", error);
            let msg = "Ops, ocorreu uma falha em resultAfterAtendimentoEffcts, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.resultAfterAtendimentoEffcts
            ))
        }
    }

    private * setShowModalCadTratamentoEffects(actions: Payload) {
        let set = actions.payload.set
        let index = actions.payload.index
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, showModalCadTratamento: set, indexTratamento: index },
            this.actionsType.setShowModalCadTratamentoEffects
        ))
    }

    private * setRowTratamentoGroupEffects(actions: Payload) {
        try {
            let row: TratamentoGroupRow = actions.payload.row
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, rowTratamentoGroup: row },
                this.actionsType.setRowTratamentoGroupEffects
            ))
        } catch (error: any) {
            console.log("error setRowTratamentoGroupEffects", error);
            let msg = "Ops, ocorreu uma falha em setRowTratamentoGroupEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.setRowTratamentoGroupEffects
            ))
        }
    }

    private * handleCancelartratamentoEffects(actions: Payload) {
        try {

            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Cancelando o tratamento...", status: "", },
                this.actionsType.handleCancelartratamentoEffects
            ))


            let atendimentoAtual = { ...this.state.row };


            let resp: ResultDb<Atendimento> = yield call(this.db.salvar, atendimentoAtual)
            if (resp.status === "ok") {
                yield put(this.reducer.actions.filterAtendimentos(this.state.filtro))
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Tratamento cancelado com sucesso!", status: "ok", row: resp.row as Atendimento },
                    this.actionsType.handleCancelartratamentoEffects
                ))

            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.handleCancelartratamentoEffects
                ))

            }

        } catch (error: any) {
            console.log("error handleCancelartratamentoEffects", error);
            let msg = "Ops, ocorreu uma falha em handleCancelartratamentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.handleCancelartratamentoEffects
            ))
        }

    }

    private * handleRealizarTratamentoEffects(actions: Payload) {
        try {

            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Atualizado tratamento...", status: "", },
                this.actionsType.handleRealizarTratamentoEffects
            ))

            let atendimentoAtual = { ...this.state.row };
            if (!isEmpty(atendimentoAtual.tratamento.procedimento)) {
                atendimentoAtual.tratamento.data_tratamento = new Date().toISOString();
                let qtDias = 31;
                if (!isEmpty(atendimentoAtual.tratamento.periodo_retorno))
                    qtDias = Number(atendimentoAtual.tratamento.periodo_retorno);
                atendimentoAtual.tratamento.data_retorno = addDays(new Date(), qtDias).toISOString();
                yield put(this.reducer.actions.salvarAtendimento(atendimentoAtual));
/*                 let resp: ResultDb<Atendimento> = yield call(this.db.salvar, atendimentoAtual)
                if (resp.status === "ok") {
                    yield put(this.reducer.actions.filterAtendimentos(this.state.filtro))
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, msg: "Tratamento atualizado com sucesso!", status: "ok", row: resp.row as Atendimento },
                        this.actionsType.handleRealizarTratamentoEffects
                    ))

                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                        this.actionsType.handleRealizarTratamentoEffects
                    ))
                }
 */            }
        } catch (error: any) {
            console.log("error handleRealizarTratamentoEffects", error);
            let msg = "Ops, ocorreu uma falha em handleRealizarTratamentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.handleRealizarTratamentoEffects
            ))
        }
    }


    private * corrigirDadosEffects(actions: Payload) {
        try {
            let atendimentos = actions.payload.atendimentos as Atendimento[];
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Corrigindo os dados...", status: "", },
                this.actionsType.corrigirDadosEffects
            ))
            for (let x = 0; x < atendimentos.length; x++) {
                const atendimento = atendimentos[x] as any;
                var tratamento = {
                    ...initialValueTratamento,
                    ...atendimento.tratamentos[0]
                }
                if (atendimento["periodo_retorno"]) {
                    tratamento["periodo_retorno"] = atendimento["periodo_retorno"];
                    tratamento["data_retorno"] = atendimento["data_retorno"];
                }
                atendimento["tratamento"] = tratamento
                //excluir os campos em atendimento
                if (atendimento["tratamento"]) {
                    delete atendimento["periodo_retorno"];
                    delete atendimento["data_retorno"];
                    delete atendimento["tratamentos"];
                }
            }
            //salvar os atendimentos corrigidos
            console.log("Atendimentos antes de salvar", atendimentos);

            let respSalvar: ResultDb<Atendimento> = yield call(this.db.salveAll, atendimentos)
            if (respSalvar.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Dados corrigidos com sucesso!", status: "ok", showAlert: true },
                    this.actionsType.corrigirDadosEffects
                ))
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: respSalvar.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.corrigirDadosEffects
                ))
            }

        } catch (error: any) {
            console.log("error corrigirDadosEffects", error);
            let msg = "Ops, ocorreu uma falha em corrigirDadosEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.corrigirDadosEffects
            ))
        }
    }

    private * novoAtendimentoEffects(actions: Payload) {
        let date = new Date();
        date.setDate(date.getDate() + listPeriodo[0].qtdias)
        yield put(pacienteController.reducer.actions.showModalSelectPaciente());
        yield put(procedimentoController.reducer.actions.selecionarProcedimento(true));
        let newPaciente: Atendimento = {
            ...initialValueAtendimento,
            data: new Date().toISOString(),
            tratamento: {
                ...initialValueTratamento,
                data_retorno: addDays(new Date(), 31).toISOString(),
                periodo_retorno: "31",
                data_tratamento: new Date().toISOString(),
            }
        }
        yield put(this.reducer.actions.set(newPaciente));
    }

    getParamFiltroApi = (filter: FiltroAtendimento): FiltroAtendimentoApi => {
        const filtroApi: FiltroAtendimentoApi = {
            situacao: filter.situacao,
            status: filter.status,
            dtIni: "",
            dtFim: "",
        };
        switch (filter.situacao) {
            case "todos":
                if (filter.status !== "todos") {
                    if (filter.status === "em_dia") {
                        filtroApi.dtIni = getDataAmerica(new Date().toISOString());
                        filtroApi.dtFim = getDataAmerica(addDays(new Date(), Number(filter.periodo_em_dia)).toISOString());
                    } else {
                        filtroApi.dtIni = getDataAmerica(addDays(new Date(), - Number(filter.periodo_em_atraso)).toISOString());
                        filtroApi.dtFim = getDataAmerica(new Date().toISOString());
                    }
                }
                return filtroApi;
            default:
                if (filter.status !== "todos") {
                    if (filter.status === "em_dia") {
                        filtroApi.dtIni = getDataAmerica(new Date().toISOString());
                        filtroApi.dtFim = getDataAmerica(addDays(new Date(), Number(filter.periodo_em_dia)).toISOString());
                    } else {
                        filtroApi.dtIni = getDataAmerica(addDays(new Date(), - Number(filter.periodo_em_atraso)).toISOString());
                        filtroApi.dtFim = getDataAmerica(new Date().toISOString());
                    }
                }
                return filtroApi
        }

    }

    getOptViewNameFiltro = (filter: FiltroAtendimento): { opt: PouchDB.Query.Options<{}, {}>, viewName: string, keyStatus: number, keyDescProcedimento: number } => {
        let opt: PouchDB.Query.Options<{}, {}> = {};
        let viewName = "";
        let dataIni = "";
        let dataFim = "";
        let keyStatus = 0;
        let keyDescProcedimento = 1;
        var status = ""
        switch (filter.situacao) {
            case "todos":
                if (filter.status === "todos") {
                    viewName = "func/tratamentos_detal_todos";
                    opt = {};
                    keyStatus = 1;
                    keyDescProcedimento = 0;
                } else {
                    viewName = "func/tratamentos_detal_todos_by_status_periodo";
                    if (filter.status === "em_dia") {
                        status = "Em Dia"
                        dataIni = getDataAmerica(new Date().toISOString());
                        dataFim = getDataAmerica(addDays(new Date(), Number(filter.periodo_em_dia)).toISOString());
                    } else {
                        status = "Em Atraso"
                        dataIni = getDataAmerica(addDays(new Date(), - Number(filter.periodo_em_atraso)).toISOString());
                        dataFim = getDataAmerica(new Date().toISOString());
                    }
                    opt = {
                        startkey: [status, dataIni.substr(0, 4), dataIni.substr(5, 2), dataIni.substr(8, 2)],
                        endkey: [status, dataFim.substr(0, 4), dataFim.substr(5, 2), dataFim.substr(8, 2)],
                    }
                    keyStatus = 0;
                    keyDescProcedimento = 4;
                }

                return { opt, viewName, keyStatus, keyDescProcedimento };
            default:
                if (filter.status === "todos") {
                    viewName = "func/tratamentos_detal_by_situacao";
                    opt = {
                        startkey: [filter.situacao],
                        endkey: [filter.situacao, {}],
                    },
                        keyStatus = 2;
                    keyDescProcedimento = 1

                } else {
                    viewName = "func/tratamentos_detal_by_status_situacao_periodo";
                    if (filter.status === "em_dia") {
                        status = "Em Dia"
                        dataIni = getDataAmerica(new Date().toISOString());
                        dataFim = getDataAmerica(addDays(new Date(), Number(filter.periodo_em_dia)).toISOString());
                    } else {//atrasado
                        status = "Em Atraso"
                        dataIni = getDataAmerica(addDays(new Date(), - Number(filter.periodo_em_atraso)).toISOString());
                        dataFim = getDataAmerica(new Date().toISOString());
                    }
                    opt = {
                        startkey: [status, filter.situacao, dataIni.substr(0, 4), dataIni.substr(5, 2), dataIni.substr(8, 2)],
                        endkey: [status, filter.situacao, dataFim.substr(0, 4), dataFim.substr(5, 2), dataFim.substr(8, 2)],
                    }
                    keyStatus = 0;
                    keyDescProcedimento = 5;

                }
                return { opt, viewName, keyStatus, keyDescProcedimento }
        }
    }


    private * filterAtendimentosEffects(actions: Payload) {
        try {
            const filter = actions.payload.filter as FiltroAtendimento;
            console.log("filterAtendimentosEffects filter", filter)

            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, msg: "Buscando registros de atendimento...", status: "", },
                this.actionsType.filterAtendimentosEffects
            ))
            //buscar os tratamentos agrupados por procedimentos
            let tratamentosGroup: TratamentosGroup[] = [];
            let respProcedimentosAgroup: ResultDb<any> = yield call(this.db.filterView, {
                viewName: "func/tratamentos_resumo_todos_by_procedimento",
                resultViewFull: true,
                opt: { group_level: 1 }
            });
            console.log("respProcedimentosAgroup", respProcedimentosAgroup)
            if (respProcedimentosAgroup.status === "ok") {
                if (respProcedimentosAgroup.rows && respProcedimentosAgroup.rows.length > 0) {
                    for (let x = 0; x < respProcedimentosAgroup.rows.length; x++) {
                        const row = respProcedimentosAgroup.rows[x];
                        tratamentosGroup.push({
                            descricao: row.key[0],
                            qt: 0,//sera somado abaixo
                            em_dia: [],
                            atrazados: []
                        })
                    }
                    /*let { opt, viewName, keyStatus, keyDescProcedimento } = this.getOptViewNameFiltro(filter);
                    let respTratamentosSit: ResultDb<AtendimentoView> = yield call(this.db.filterView, {
                        viewName: viewName,
                        resultViewFull: true,
                        opt: opt
                    });//colocar os filtros
                    */

                    let filtroApi = this.getParamFiltroApi(filter);
                    let respTratamentosSit: { status: string, rows: { emdias: Atendimento[], ematraso: Atendimento[] }, msg:string } = yield call(getAtendimentos, filtroApi);;
                    console.log("respTratamentosSit", respTratamentosSit)
                    if (respTratamentosSit.status === "ok") {
                        //fazer a separacao dos registros de acordo com o tratamento

                        if (respTratamentosSit.rows) {
                            //fazer um loop em tratamentosGroup e adicionar conforme o procedimento do tratamento for encontrado no grupo de tratamentos agrupados por procedimento
                            for (let x = 0; x < tratamentosGroup.length; x++) {
                                const tg = tratamentosGroup[x];
                                //filtrar os registros de acordo com o procedimento do tratamento e situacao do tratamento
                                let emDia = respTratamentosSit.rows.emdias.filter(value => value.tratamento.procedimento.descricao === tg.descricao);
                                let atrasados = respTratamentosSit.rows.ematraso.filter(value => value.tratamento.procedimento.descricao === tg.descricao);
                                tg.em_dia = emDia;
                                tg.atrazados = atrasados;
                                tg.qt = tg.atrazados.length + tg.em_dia.length;
                            }

                        }


                        //yield put(this.reducer.actions.read());
                        let rows:Atendimento[] = [];
                        //adcionar todos os registro de atendiemnto em rows os emdias e ematraso
                        for (let x = 0; x < tratamentosGroup.length; x++) {
                            const tg = tratamentosGroup[x];
                            rows = [...rows, ...tg.em_dia, ...tg.atrazados]
                        }


                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, loadingRows: false, status: "ok", rowsTratamentosBySituacao: tratamentosGroup, rowTratamentoGroup: {} as TratamentoGroupRow, rows: rows   },
                            this.actionsType.filterAtendimentosEffects
                        ))

                        console.log("finalizou")
                    } else {
                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, loadingRows: false, status: "error", msg: respTratamentosSit.msg, showAlert: true, rowsTratamentosBySituacao: [], rowTratamentoGroup: {} as TratamentoGroupRow },
                            this.actionsType.filterAtendimentosEffects
                        ))

                    }

                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loadingRows: false, status: "ok", msg: "Sem registros na central de atendimentos.", showAlert: true, rowsTratamentosBySituacao: [], rowTratamentoGroup: {} as TratamentoGroupRow },
                        this.actionsType.filterAtendimentosEffects
                    ))

                }
            } else {
                console.log("Resp nao ok", respProcedimentosAgroup)
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, msg: respProcedimentosAgroup.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.filterAtendimentosEffects
                ))
            }

        } catch (error: any) {
            console.log("error filterAtendimentosEffects", error);
            let msg = "Ops, ocorreu uma falha em filterAtendimentosEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.filterAtendimentosEffects
            ))
        }
    }
}

export const atendimentoController = new AtendimentoController()

export const mapStateToAtendimentoProps = (state: ApplicationState) => ({
    atendimentoState: state.atendimentoState,
})

export const mapDispatchToAtendimentoProps = (dispatch: Dispatch) => ({
    atendimentoActions: bindActionCreators({ ...atendimentoController.reducer.actions }, dispatch),
    pacienteActions: bindActionCreators({ ...pacienteController.reducer.actions }, dispatch),
    procedimentoActions: bindActionCreators({ ...procedimentoController.reducer.actions }, dispatch),
})
